export const marketingConstants = {
  androidStoreLink: "",
  iosStoreLink: "",
} as const;
